<i18n lang="yaml">
en:
  delete_key_confirm: Are you sure you want to delete this key?
ru:
  delete_key_confirm: Вы уверены, что хотите удалить этот ключ?
</i18n>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({
  comment: {
    type: String,
    required: true
  },
  fingerprint: {
    type: String,
    required: true
  },
  key_type: {
    type: String,
    required: true
  },
  material: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['delete'])

async function remove() {
  if (confirm(t('delete_key_confirm'))) {
    emit('delete', props.material)
  }
}
</script>

<template>
  <div class="card h-100 p-2">
    <div class="card-body">
      <img src="@/assets/key.svg" class="mb-2" />
      <kbd class="ms-2">{{ key_type }}</kbd>
      <button @click="remove" class="btn btn-danger btn-close float-end" />
      <h5 class="card-title">
        {{ comment }}
      </h5>
      <h6 class="card-subtitle text-muted mt-2">
        <code>{{ fingerprint }}</code>
      </h6>
    </div>
  </div>
</template>

<style scoped>
.card {
  /* border-radius: 4px; */
  background: #fff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.12),
    0 4px 8px rgba(0, 0, 0, 0.06);
}
</style>
